import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../components/Button';
import ModalBody from 'react-bootstrap/ModalBody';
import GenericList, { GenericListItem } from '../../../components/GenericList';
import Link from '../../../components/Link/Link';
import ModalHeader from '../../../components/ModalHeader';
import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';

export type customBenefitModalCobraProps = {
  showBenefitModalCobra: boolean;
  handleCloseBenefitModalCobra: () => void;
};

const BenefitModalCobra = ({
  showBenefitModalCobra,
  handleCloseBenefitModalCobra,
}: customBenefitModalCobraProps) => {
  return (
    <Modal
      show={showBenefitModalCobra}
      onHide={handleCloseBenefitModalCobra}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Benefit Information</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Row className="pb-12">
            <Container className="d-flex justify-content-center img-wrapper">
              <img
                className="w-100"
                src={`${process.env.PUBLIC_URL}/${'benefit-img.svg'}`}
                alt="benefit-img"
              />
            </Container>
            <Container>
              <p>
               You are now eligible to enroll in COBRA Continuation Coverage for yourself and your eligible dependents. 
              </p>
            </Container>
          </Row>
 
           
          <Row className="pb-12">
            <Container className="px-7 py-5 list-cointainer">
              <GenericList>
              <h5 className="pb-10">Helpful Tools</h5>
                <GenericListItem>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    eventKey="test"
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                  >
                    Important Information
                  </Link>
                </GenericListItem>
               
                
              </GenericList>

            </Container>
          </Row>
          <section className="mb-5 d-flex flex-column flex-lg-row justify-content-center">
            <Button
              onClick={handleCloseBenefitModalCobra}
              className="text-nowrap order-2 order-lg-1 mt-7 mt-lg-0 me-lg-7"
              variant="primary-outline"
            >
              Close
            </Button>
          </section>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default BenefitModalCobra;
